import { GetOrdersWithFilterService } from "../Infrastructure/Business.service";

export default async function GetOrdersWithFilterLogic(zone, updatedAt, status){
  return await GetOrdersWithFilterService(zone, updatedAt, status);
}